import { InfoTip } from '../../../components/ui/InfoTip';
import { MarketingPeriodControl, Toolbar, useMarketingPeriod } from '../../Marketing/shared';
import { ContentCalendar } from './ContentCalendar';
import { ContentView } from './ContentView';
import { RefreshList } from './RefreshList';

/**
 * Marketing → Content → Opportunities: what to write next. The top AI citation
 * gaps lead, then the Monday refresh list, then the content calendar (one line when it has nothing),
 * then the quick wins and demand shifts that used to sit two tab levels deep
 * under the GTM board.
 */
export function OpportunitiesView() {
  const p = useMarketingPeriod();
  const { startDate, endDate } = p.period;

  // The period control drives every panel except the calendar, a fixed upcoming window that says so.
  return (
    <div className="space-y-6">
      <Toolbar
        start={
          <div className="flex items-center gap-2">
            <h2 className="text-body-md font-medium text-text-primary">What to write next</h2>
            <InfoTip label="About these opportunities">
              The refresh list and the calendar are built each Monday, whatever the period. The gaps, quick wins and
              traffic panels use the selected period, from Search Console, Peec, Semrush, DataForSEO volumes and RB2B
              visits. Each panel loads on its own; a source that fails is listed above the panels.
            </InfoTip>
          </div>
        }
        end={<MarketingPeriodControl p={p} />}
      />
      <ContentView startDate={startDate} endDate={endDate} periodLabel={p.label} afterLead={<><RefreshList /><ContentCalendar /></>} />
    </div>
  );
}
